import { useState } from "react";
import { Form, Input, Select, DatePicker } from "antd";
import LoadingButton from '@mui/lab/LoadingButton';
import GenericModal from "../../../components/buttons/genericModal";
import { backendPostWithoutRefresh } from "../../../helpers/callBackend";
import Button from '@mui/material/Button';
import moment from 'moment';

const NewGeneralLedgerRule = (props) => {
    const [visible, setVisible] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [form] = Form.useForm();

    const onFormSubmit = (values) => {
        setSubmitting(true);
        const data = {
            ...values,
            ...(values?.date_range?.length == 2
                ? {
                    custom_start_date: moment.utc(values.date_range[0]).format('YYYY-MM-DD HH:mm:ss.SSSSSS'),
                    custom_end_date: moment.utc(values.date_range[1]).format('YYYY-MM-DD HH:mm:ss.SSSSSS'),
                }
                : {})
        };

        backendPostWithoutRefresh("/api/general-ledger/rules/", data)
            .then((res) => {
                setVisible(false);
                props.onSuccess(res?.data?.general_ledger_tag_rule);
            })
            .catch((error) => {
                console.error('Error:', error);
            })
            .finally(() => {
                setSubmitting(false);
            });
    };

    return (
        <GenericModal
            visible={visible}
            handleCancelModal={() => setVisible(false)}
            showModal={() => setVisible(true)}
            size="md"
            button={
                <Button sx={{ fontSize: 14, textTransform: 'none' }} disableElevation fullWidth size="small" variant="contained" color="primary">
                    + Add New
                </Button>
            }
            modalTitle={props.title}
            modalBody={
                <Form
                    form={form}
                    layout="inline"
                    colon={false}
                    onFinish={onFormSubmit}
                >
                    <Form.Item
                        label={<label style={{ marginRight: 121 }}> Rule Name: </label>}
                        name="name"
                        style={{ marginBottom: 10 }}
                        rules={[{ required: true }]}
                    >
                        <Input placeholder="Enter rule name" style={{ width: 300 }} />
                    </Form.Item>

                    <Form.Item
                        label={<label style={{ marginRight: 116 }}> Description: </label>}
                        name="description"
                        style={{ marginBottom: 10 }}
                        rules={[{ required: true }]}
                    >
                        <Input placeholder="Enter description" style={{ width: 300 }} />
                    </Form.Item>

                    <Form.Item
                        label={<label style={{ marginRight: 109 }}> Search Term: </label>}
                        name="search_term"
                        style={{ marginBottom: 10 }}
                        rules={[{ required: true }]}
                    >
                        <Input placeholder="Enter search term (regex)" style={{ width: 300 }} />
                    </Form.Item>

                    <Form.Item
                        label={<label style={{ marginRight: 73 }}> Account Grouping: </label>}
                        name="grouping_type"
                        rules={[{ required: true }]}
                        style={{ marginBottom: 10 }}
                    >
                        <Select
                            style={{ width: 300 }}
                            dropdownMatchSelectWidth={false}
                            placeholder="Select Account Grouping"
                            onChange={(e) => {
                                props.setGroupingType(e);
                                form.setFieldsValue({ group_id: undefined });
                            }}
                        >
                            {props.groupingTypeFilter.map((option) => (
                                <Select.Option key={option.value} value={option.value}>
                                    {option.label}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label={<label style={{ marginRight: 149 }}> Group: </label>}
                        name="group_id"
                        rules={[{ required: true }]}
                        style={{ marginBottom: 10 }}
                    >
                        <Select
                            style={{ width: 300 }}
                            disabled={props.selectGroupFilter.length === 0 || props.loadingGroupingOptions}
                            loading={props.loadingGroupingOptions}
                            placeholder="Select Group"
                            dropdownMatchSelectWidth={false}
                            onChange={(e) => props.setSelectGroup(e)}
                            key={props.selectGroup}
                        >
                            {props.selectGroupFilter.map((item) => (
                                <Select.Option key={item.id} value={item.id}>
                                    {item.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label={<label style={{ marginRight: 109 }}> G/L Account: </label>}
                        name="gl_account_id"
                        rules={[{ required: true }]}
                        style={{ marginBottom: 10 }}
                    >
                        <Select
                            style={{ width: 300 }}
                            placeholder="Select G/L Account"
                            dropdownMatchSelectWidth={false}
                        >
                            {props.generalLedgerAccount.map((option) => (
                                <Select.Option key={option.id} value={option.id}>
                                    {option.code} {option.description}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label={<label style={{ marginRight: 80 }}> Date Range: </label>}
                        name="date_range"
                        rules={[{ required: true }]}
                    >
                        <DatePicker.RangePicker style={{ width: 300, marginLeft: 33 }} />
                    </Form.Item>

                    <Form.Item>
                        <LoadingButton
                            disableElevation
                            fullWidth
                            size="small"
                            type="submit"
                            variant="contained"
                            color="primary"
                            loading={submitting}
                            loadingPosition="start"
                            sx={{ fontSize: 14, textTransform: 'none' }}
                            style={{ margin: "3px", marginTop: "20px", width: "100px" }}
                        >
                            Submit
                        </LoadingButton>
                    </Form.Item>
                </Form>
            }
        />
    );
};

export default NewGeneralLedgerRule;
